var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    attrs: {
      "id": "appInner"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "usertx"
  }, _vm._l((_vm.infor), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "usertxbackground",
      on: {
        "click": function($event) {
          _vm.current(item.id)
        }
      }
    }, [_c('p', {
      staticClass: "usertxp1"
    }, [_c('a', [_vm._v(_vm._s(item.name))]), _c('span', [_vm._v(_vm._s(item.time))])]), _vm._v(" "), _c('p', {
      staticClass: "usertxp2"
    }, [_vm._v(_vm._s(item.content))]), _vm._v(" "), _c('span', {
      staticClass: "userno",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.delinfor(item.id)
        }
      }
    })])
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c500e2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = woAb
// module chunks = 1